import { devMockResponse } from './dev-mock-data';

/**
 * THE transport for the `/api/premium/*` routes — a credentialed `fetch` that asks the dev mock layer
 * first.
 *
 * Those routes are deliberately NOT read through `apiFetch` (they are not instance-auth aware), so the
 * app's one interception point never sees them and the dev panel's "Plan tier" / "Payment history"
 * rows could not move the plan card. This is the second door into the mock layer (the first being
 * `apiFetch` itself), and `test/dev-tools-gated.test.ts` allowlists it by name — which is why it is a
 * module of its own rather than a helper inside whichever component happened to need it first. A
 * premium route added anywhere must come through here, or its row silently stops working.
 *
 * Off a dev build (and off the corporate network on a deployed origin) `devMockResponse` always
 * returns `undefined`, so a real user's browser performs the identical request it always did.
 */
export function premiumFetch(url: string): Promise<Response> {
  return Promise.resolve(devMockResponse(url) ?? fetch(url, { credentials: 'include' }));
}
